module.exports = __webpack_public_path__ + "img/TODO.1c29c58c.png";